import api, {HTTPMethod} from '@/helpers/api'
import {
  GetApplicationsRequest,
  GetApplicationsRequestSchema,
  GetApplicationsResponse,
  GetApplicationsResponseSchema,
} from '@/types/Applications'
import {ENDPOINTS} from '@/config/constants'

export const getApplicationsService = (signal?: AbortSignal) => {
  return api<GetApplicationsRequest, GetApplicationsResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_TENANT_COUNTRIES,
    requestSchema: GetApplicationsRequestSchema,
    responseSchema: GetApplicationsResponseSchema,
    signal,
    includeContextHeaders: false,
  })()
}
